import React from 'react';
import { useTheme, useMediaQuery } from '@mui/material';
import HomePageDesktop from './HomePageDesktop';
import HomePageMobile from './HomePageMobile';

const HomePageMain = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // sm = 600px breakpoint

  return isMobile ? <HomePageMobile /> : <HomePageDesktop />;
};

export default HomePageMain;

